module.exports.percival = {
  vi: {
    title: 'Percival trong Avalon: năng lực và chiến thuật',
    description:
      'Percival thấy ai trong Avalon? Tìm hiểu Merlin và Morgana xuất hiện ra sao, những điều Percival không biết và cách bảo vệ Merlin mà không làm lộ danh tính.',
    keywords: ['Percival', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Percival em Avalon: habilidades e estratégia',
    description:
      'Quem Percival vê em Avalon? Saiba como Merlin e Morgana aparecem, quais informações ele não tem e como proteger Merlin sem revelar sua identidade.',
    keywords: ['Percival', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Percival in Avalon: Abilities & Strategy',
    description:
      'Who does Percival see in Avalon? Learn how Merlin and Morgana appear, what Percival cannot know, and how to protect Merlin without revealing him.',
    keywords: ['Percival', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Персиваль в Авалоне: способности и стратегия',
    description:
      'Кого видит Персиваль в Авалоне? Как отличить Мерлина от Морганы, чего Персиваль не знает и как защищать Мерлина, не раскрывая его роль.',
    keywords: ['Персиваль', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆派西維爾：角色能力與玩法策略',
    description:
      '阿瓦隆派西維爾能看到誰？了解梅林與莫甘娜的候選關係、派西維爾不知道的資訊，以及如何保護梅林而不暴露身分。',
    keywords: ['派西維爾', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆派西维尔：角色能力与玩法策略',
    description:
      '阿瓦隆派西维尔能看到谁？了解梅林与莫甘娜的候选关系、派西维尔不知道的信息，以及如何保护梅林而不暴露身份。',
    keywords: ['派西维尔', '角色', '规则', '建议'],
  },
  es: {
    title: 'Percival en Avalon: habilidades y estrategia',
    description:
      '¿A quién ve Percival en Avalon? Aprende cómo aparecen Merlín y Morgana, qué información le falta y cómo proteger a Merlín sin revelar su identidad.',
    keywords: ['Perceval', 'Rol', 'Reglas', 'Consejos'],
  },
};
